import {
    useAppSelector,
    useAppSelectorWithShallowEquality,
} from '../index'
import {NinchatProperties} from 'api/types'
import {getGroupQueues} from 'selectors/ninchat/groups'

export type GroupQueueEntry = ReturnType<typeof getGroupQueues>[number]

export type QueueTimeContext = {
    groupQueues: GroupQueueEntry[]
    isGroupQueue: boolean
    parentGroupQueue?: NinchatProperties.NinchatUserQueue
    queue: NinchatProperties.NinchatUserQueue | undefined
}

export const useQueueTimeContext = (
    queue_id: NinchatProperties.QueueID,
): QueueTimeContext => {
    const queue = useAppSelector((state) => state.ninchat.user_queues?.[queue_id] ?? state.ninchat._queues?.[queue_id])
    const parentGroupQueueId = queue?.queue_attrs.group_id
    const parentGroupQueue = useAppSelector((state) => (parentGroupQueueId
        ? state.ninchat.user_queues?.[parentGroupQueueId] ?? state.ninchat._queues?.[parentGroupQueueId]
        : undefined))
    const isGroupQueue = !!queue?.queue_attrs.is_group
    const groupQueues = useAppSelectorWithShallowEquality((state) => getGroupQueues(state, isGroupQueue, queue_id))

    return {
        groupQueues,
        isGroupQueue,
        parentGroupQueue,
        queue,
    }
}
